import React from "react";
import { useACL } from "layouts/agent/agent-info/agent-acl/_context/AgentACLContext";
import ACLSelect from "../../components/ACLSelect";
import { ACLEntryPermission, ACLPayload } from "types";
import api from "api/axios";
import { useAgentInfo } from "layouts/agent/agent-info/_context/AgentInfoContext";
import { handleAxiosAndCaughtError } from "utils";
import { useTranslation } from "react-i18next";

const UserACLEdit = ({
  permission,
  id,
}: {
  permission: ACLEntryPermission[] | null;
  id: string;
}) => {
  const { t } = useTranslation();
  const { permissions, refetch } = useACL();
  const { agentInfo } = useAgentInfo();
  const [aclEntries, setAclEntries] = React.useState<ACLEntryPermission[]>(
    permission ||
      permissions.map((perm) => ({ permission: perm, access: "NOT_SET" }))
  );
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const payload: ACLPayload = {
        subject_type: "USER",
        subject_id: id,
        entries: aclEntries,
      };
      await api.put(`/agents/${agentInfo.id}/acl`, payload);
      await refetch();
    } catch (err) {
      handleAxiosAndCaughtError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="md:w-[50vh]">
      <div className="mb-6 flex flex-col gap-4">
        <ACLSelect
          permissions={permissions}
          value={aclEntries}
          onChange={setAclEntries}
          loading={isLoading}
        />
      </div>
      <div className="mt-4 flex justify-end gap-2">
        <button
          type="submit"
          disabled={isLoading}
          className={`rounded-lg bg-purple-500 px-4 py-1 text-lg font-semibold text-white transition hover:bg-purple-600 ${
            isLoading ? "cursor-not-allowed opacity-50" : ""
          }`}
        >
          {isLoading ? t("agents.acl.saving") : t("agents.acl.saveChanges")}
        </button>
      </div>
    </form>
  );
};

export default UserACLEdit;
